<div *ngIf="show" class="toast-container">
 <div class="toast-content"  [ngClass]="{'toast-content-error': type === 'error' ? true : false}">
   <div class="container ">
<div class="row vertical-align">
  <div class="col-9">
      <span>{{message}}</span>
  </div>
  <div class="col-3">
      <img src="../../../assets/images/ajax-loader.gif" />
  </div>
</div>
   </div>
 </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/save-toast/save-toast.component.html